var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-hd",attrs:{"id":"应用截图"}},[_c('h2',{staticClass:"title"},[_vm._v("企业端（车修修）应用截图")])])}]

export { render, staticRenderFns }